import { MultiValueRenderer } from '@/components/shared/fields/MultiValueRenderer';
import { PHONE_LABELS } from '@/types/fieldRegistry';
import type { MultiValueEntry } from '@/types/fieldRegistry';
import { formatPhoneForDisplay } from '@/lib/phone-mask';
import { validateLeadPhone } from '@/lib/leads/leadPhones';

interface LeadPhonesFieldProps {
  value: MultiValueEntry[] | string | null;
  onChange: (entries: MultiValueEntry[]) => void;
  disabled?: boolean;
}

/**
 * Editor da lista de telefones do lead. É o `MultiValueRenderer` já configurado com os rótulos
 * do registry, a escolha de principal, a máscara brasileira e a validação da faixa canônica
 * (12–13 dígitos, a mesma que `lead_phones` aceita).
 */
export function LeadPhonesField({ value, onChange, disabled }: LeadPhonesFieldProps) {
  return (
    <MultiValueRenderer
      value={value}
      onChange={onChange}
      labels={PHONE_LABELS}
      inputType="tel"
      placeholder="Telefone"
      disabled={disabled}
      showPrimary
      mask={formatPhoneForDisplay}
      validate={validateLeadPhone}
    />
  );
}
